import React from 'react';

// import { ReactComponent as CalendarIcon } from '@assets/images/calendarIcon.svg';
import { ReactComponent as ChatIcon } from '@assets/images/chatIcon.svg';
import { ReactComponent as ThumbIcon } from '@assets/images/thumbIcon.svg';
import { ReactComponent as LockIcon } from '@assets/images/lockIcon.svg';
import './styles.scss';

export const INFO_SECTION_DATA = [
  /* {
    icon: <CalendarIcon />,
    title: 'checkout.info.guestCheckout.title',
    description: 'checkout.info.guestCheckout.description',
  },*/
  {
    icon: <ChatIcon />,
    title: 'checkout.info.needHelp.title',
    description: 'checkout.info.needHelp.description',
  },
  {
    icon: <ThumbIcon />,
    title: 'checkout.info.buyerGuaranteed.title',
    description: 'checkout.info.buyerGuaranteed.description',
  },
  {
    icon: <LockIcon />,
    title: 'checkout.info.sslProtection.title',
    description: 'checkout.info.sslProtection.description',
  },
];
